import { createAction } from '@af-common/Common/_actions/Action';

export enum IntroActionType {
	OnIntroOpen = 'ON_INTRO_OPEN',
}

export const OnIntroOpen = (value: boolean) => createAction(IntroActionType.OnIntroOpen, {
	value: value
});

export type IntroAction = 
	ReturnType<typeof OnIntroOpen>